module.exports = __webpack_public_path__ + "img/Al-Ghadeer1.995aa94c.jpeg";